import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "bx_modal_reset_password",
  ref: "changePasswordModalRef",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered w-200px mx-auto" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "text-center p-2" }
const _hoisted_5 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          _createElementVNode("h4", _hoisted_4, _toDisplayString(_ctx.lineId), 1),
          (_ctx.lineQrCodeUrl)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: _ctx.lineQrCodeUrl,
                class: "img-fluid",
                alt: ""
              }, null, 8, _hoisted_5))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ], 512))
}